import React, { forwardRef } from 'react'

const LoadMoreButton = forwardRef(({ onLoadMore, isLoading }, ref) => {
  const handleClick = e => {
    if (!isLoading) {
      onLoadMore(e)
    }
  }

  return (
    <div className="center">
      <button
        ref={ref}
        className="ui active button load-more-btn"
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? 'Loading...' : 'Load More'}
      </button>
    </div>
  )
})

LoadMoreButton.displayName = 'LoadMoreButton'

export default LoadMoreButton
